import React from 'react'

const IconPhone = props => (
  <svg
    className="icon"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m14.314 14.567.543 4.638m1.5-8.279.648 6.319m-.109 10.63 8.65-5.14a.95.95 0 0 0 .332-1.276L16.344 4.467a.894.894 0 0 0-1.24-.342l-8.65 5.14a.95.95 0 0 0-.332 1.275l9.534 16.993c.25.447.806.6 1.24.342ZM7.03 12.159l10.222-6.073L24.97 19.84l-10.222 6.073L7.03 12.16Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default IconPhone
